var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-lista-estoque',{attrs:{"estoques":_vm.estoques,"loading":_vm.loading,"on-change-options":_vm.onChangeOptions,"options-list":_vm.optionsList},on:{"update":_vm.onClickRefresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }